export default "__VITE_ASSET__DOxPNn0Z__"